import { Global, css } from '@emotion/react'

/**
 * @todo Use responsive fonts (ie. WebM, WebS, WebXL)
 */
export const GlobalStyles = () => (
  <Global
    styles={css`
      @font-face {
        font-family: 'ABC Arizona Text';
        font-weight: 700;
        font-display: fallback;
        src: url('/fonts/ABCArizonaText-Bold.woff') format('woff'),
          url('/fonts/ABCArizonaText-Bold.woff2') format('woff2');
      }

      @font-face {
        font-family: 'Suisse Intl';
        font-weight: 400;
        font-display: fallback;
        src: url('/fonts/SuisseIntl-Regular-WebM.woff') format('woff'),
          url('/fonts/SuisseIntl-Regular-WebM.woff2') format('woff2');
      }

      @font-face {
        font-family: 'Suisse Intl';
        font-weight: 500;
        font-display: fallback;
        src: url('/fonts/SuisseIntl-Medium-WebM.woff') format('woff'),
          url('/fonts/SuisseIntl-Medium-WebM.woff2') format('woff2');
      }

      @font-face {
        font-family: 'Suisse Intl Mono';
        font-weight: 400;
        font-display: fallback;
        src: url('/fonts/SuisseIntlMono-Regular-WebXL.woff') format('woff'),
          url('/fonts/SuisseIntlMono-Regular-WebXL.woff2') format('woff2');
      }

      .PhoneInput input {
        background: none;
      }

      .getAddressContainer {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        background: var(--gaia-colors-white);
        border-radius: 10px;
        padding: var(--gaia-space-lg);
      }

      .getAddressContainer > * {
        flex: 0 0 40%;
      }

      .getAddressContainer > div:last-child {
        flex-basis: 100%;
        margin-top: var(--gaia-space-lg);
      }
    `}
  />
)
